export const AdditionalErrorMessages = {
  NotEnoughFreeBets: 'NOT_ENOUGH_FREE_BETS',
};

export const AdditionalNotificationByResponseCode = {
  NotEnoughFreeBets: 'error',
};

export const AdditionalResponseCode = {
  1012: 'NotEnoughFreeBets',
};
export const betResponseCodeByName = {
  NotEnoughFreeBets: 1012,
};
